import { monoCell, textCell } from "@/components/ui/table-cell";
import type { TableBlock } from "@/types/blocks";

import { EntityLink } from "../EntityLink";
import { isEntityRef } from "../entity-refs";

/** A Maxwell table block. Cells go through the shared `textCell`/`monoCell`
 *  helpers (house rule: never author cell typography). Numeric columns use
 *  `monoCell` and right-align; a row with an `entity_ref` deep-links its
 *  first cell. */
export function TableBlockView({ block }: { block: TableBlock }) {
  return (
    <div className="overflow-hidden rounded-md border border-border bg-card">
      {block.title && (
        <div className="border-b border-border px-3 py-2 text-sm font-medium text-foreground">
          {block.title}
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-left">
          <thead>
            <tr className="border-b border-border">
              {block.columns.map((c) => (
                <th
                  key={c.key}
                  className={`px-3 py-2 text-xs font-medium text-muted-foreground ${
                    c.numeric ? "text-right" : "text-left"
                  }`}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {block.rows.map((row, ri) => (
              <tr key={ri} className="border-b border-border last:border-0">
                {row.cells.map((value, ci) => {
                  const col = block.columns[ci];
                  const numeric = col?.numeric ?? false;
                  const linkRef = ci === 0 && isEntityRef(row.entity_ref) ? row.entity_ref : null;
                  return (
                    <td
                      key={ci}
                      className={`px-3 py-2 align-top ${numeric ? "text-right" : "text-left"}`}
                    >
                      {linkRef ? (
                        <EntityLink entity={linkRef} />
                      ) : numeric ? (
                        monoCell(value)
                      ) : (
                        textCell(value)
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
